export default __webpack_public_path__ + "static/media/x33-logo-anniversary.53d188ae.png";